"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenerations = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getGenerations = function () {
    return core_1.default.get({ url: '/generations' });
};
exports.getGenerations = getGenerations;
